import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import MuiCard from '@mui/material/Card';
import { Paragraph } from 'src/interviews/components/Layout/Embedded';

import type { ReactNode, RefObject } from 'react';

function Card({
  className,
  cta,
  href,
  description,
  innerRef,
  subtitle,
  title,
  onClick,
  containerClassName,
  children,
}: {
  className?: string;
  cta?: ReactNode;
  href: string;
  description?: ReactNode;
  innerRef?: RefObject<HTMLDivElement>;
  subtitle?: ReactNode;
  title: string;
  onClick?: () => void;
  containerClassName?: string;
  children?: ReactNode;
}) {
  return (
    <div className={`bp-flex bp-shrink-0 ${containerClassName}`} ref={innerRef}>
      <MuiCard variant="outlined" className={`bp-h-full ${className}`}>
        <CardActionArea
          href={href}
          target="_blank"
          className="bp-flex bp-h-full bp-items-stretch"
          onClick={onClick}
        >
          <CardContent>
            <div className="bp-flex bp-h-full bp-flex-col bp-items-stretch bp-gap-3.5">
              <span className="bp-leading-[120%]">{subtitle}</span>
              <Paragraph>{title}</Paragraph>
              {description && (
                <p className="bp-font-secondary-small bp-my-0 bp-line-clamp-5 bp-text-ellipsis">
                  {description}
                </p>
              )}
              {children}
              {cta}
            </div>
          </CardContent>
        </CardActionArea>
      </MuiCard>
    </div>
  );
}

export default Card;
